import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const ENCOUNTERS_QUERY_KEY = "ENCOUNTERS_QUERY_KEY";

export const useEncountersQuery = (patientUserId) => {
  return useQuery({
    queryKey: [ENCOUNTERS_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: listEncounters.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    enabled: !!patientUserId,
  });
};

export const useEncountersByProviderIdQuery = (
  patientUserId,
  providerUserId
) => {
  return useQuery({
    queryKey: [ENCOUNTERS_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: listEncounters.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    select: (encounter) =>
      encounter.filter((e) => e.providerUserId === providerUserId),
    enabled: !!patientUserId,
  });
};

export const useEncountersByIdQuery = (patientUserId, id) => {
  return useQuery({
    queryKey: [ENCOUNTERS_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: listEncounters.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    select: (encounter) => encounter.filter((e) => e.id === id)[0],
    enabled: !!patientUserId,
  });
};

const listEncounters = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "appointmentsapi",
    path: "/encounters/" + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
